export default __webpack_public_path__ + "static/media/konrad.53cae94d.jpg";